import { experimentCore } from './experimentCore'

export const confirmExperiments = {
    confirmParticipate: experimentCore.confirmParticipate,
    confirmSplit: experimentCore.confirmSplit,
}
